import type { ListRegistryTag } from "../types";

/**
 * 検索条件で選んだタグを先に並べる（それ以外の並びは変えない）。
 * 一覧は先頭の数個だけ出して残りを「ほかN」にまとめるため、法人が検索に当たった理由のタグを隠さないようにする。
 * @param tags 法人に付いたタグ（BE の並び）
 * @param selectedCodes 検索条件で選んだタグのコード
 * @returns 並べ替えたタグ
 */
export const prioritizeSelectedTags = (
  tags: ListRegistryTag[],
  selectedCodes: readonly string[]
): ListRegistryTag[] => {
  if (!selectedCodes.length) return tags;
  const selected = new Set(selectedCodes);
  return [
    ...tags.filter((tag) => selected.has(tag.code)),
    ...tags.filter((tag) => !selected.has(tag.code)),
  ];
};
